module.exports = __webpack_public_path__ + "img/qrcode-org.59b24d0b.png";